module.exports = __webpack_public_path__ + "img/ueno-schedule.683676f4.png";